import { render } from "./Signin.vue?vue&type=template&id=12164109"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"
script.render = render

export default script